import { generatePath } from 'react-router-dom';

import { Navigate, useTypedParams } from '@sorare/routing';

import { FOOTBALL_SCOUTING_CENTER_PLAYERS_LEADERBOARDGROUP } from '@sorare/core/src/constants/__generated__/routes';

import { PageParams } from './__generated__/routeParams';

export const ScoutingCenterSo5LeaderboardGroupRedirect = () => {
  const { leaderboardGroup } = useTypedParams<PageParams>();
  return (
    <Navigate
      to={generatePath(FOOTBALL_SCOUTING_CENTER_PLAYERS_LEADERBOARDGROUP, {
        leaderboardGroup,
      })}
    />
  );
};

export default ScoutingCenterSo5LeaderboardGroupRedirect;
